import React from "react";
import {Alert, Box, Card, CardContent, MenuItem, TextField, Typography} from "@mui/material";
import {reportingPreset, todayDate} from "./analytics-filters";

const fieldLayout = (basis, grow = 1) => ({flex: {xs: "1 1 100%", sm: `${grow} 1 ${basis}px`}, minWidth: 0});

export default function AnalyticsFilterForm({draft, setDraft, error, pending, t}) {
    const change = (key, value) => setDraft(previous => ({...previous, [key]: value}));
    const preset = value => setDraft(previous => ({...previous, preset: value,
        ...(value === "custom" ? {} : reportingPreset(value))}));
    return <Card component="form" onSubmit={event => event.preventDefault()} sx={{mb: 2}}>
        <CardContent sx={{p: 2, "&:last-child": {pb: 2}}}>
        <Typography variant="subtitle1" gutterBottom>{t("AnalyticsFilters")}</Typography>
        <Box sx={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5}}>
            <Box sx={fieldLayout(220, 1.2)}><TextField size="small" select fullWidth label={t("AnalyticsPeriod")} value={draft.preset}
                onChange={event => preset(event.target.value)}>
                {["7", "30", "month", "custom"].map(value => <MenuItem key={value} value={value}>{t(`AnalyticsPeriod_${value}`)}</MenuItem>)}
            </TextField></Box>
            {["from", "to"].map(key => <Box sx={fieldLayout(160)} key={key}>
                <TextField size="small" fullWidth type="date" label={t(key === "from" ? "FromDate" : "ToDate")} value={draft[key]}
                    InputLabelProps={{shrink: true}} inputProps={{max: todayDate()}}
                    onChange={event => setDraft(previous => ({...previous, preset: "custom", [key]: event.target.value}))}/>
            </Box>)}
            <Box sx={fieldLayout(156, 0)}><TextField size="small" fullWidth type="number" label={t("NumberOfProducts")} value={draft.limit}
                inputProps={{min: 1, max: 50, step: 1}} onChange={event => change("limit", event.target.value)}/></Box>
            <Box sx={fieldLayout(210, 1.3)}><TextField size="small" select fullWidth label={t("AnalyticsRankBy")} value={draft.rankBy}
                onChange={event => change("rankBy", event.target.value)}>
                <MenuItem value="UNITS">{t("DistributorUnitsSold")}</MenuItem>
                <MenuItem value="SALES_AMOUNT">{t("DistributorSalesAmount")}</MenuItem>
            </TextField></Box>
        </Box>
        {pending && <Typography role="status" variant="body2" color="text.secondary" sx={{mt: 1.5}}>{t("AnalyticsUpdating")}</Typography>}
        <Typography variant="caption" display="block" sx={{mt: 1.5}}>{t("AnalyticsAutoUpdate")} {t("AnalyticsDateBoundary")}</Typography>
        {error && <Alert severity="error" sx={{mt: 2}}>{t(error)}</Alert>}
    </CardContent></Card>;
}
